/*
 * fof/pages no jeito do Canela: a página (/p/{id}-…) sai sem o hero cinza
 * da extensão; o título vai para dentro do cartão, como o das Diretrizes.
 *
 * Uma página que é aba da área Sobre (Termos, Privacidade, as abas extras)
 * abre lá, com as abas, mesmo quem chega pelo /p/{id}: o mesmo conteúdo não
 * fica com dois visuais.
 */
import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import { aboutPageUrl, findAboutPage, findLegalPage } from '../features/community/AboutNav';
import { forumBool } from '../utils/settings';

/** O endereço da página na área Sobre, quando ela é uma aba de lá. */
function aboutUrlFor(id) {
  if (!id || !forumBool('canelaAboutEnabled', true)) return null;
  const tab = findAboutPage(id);
  if (tab) return aboutPageUrl(tab);
  const legal = findLegalPage(id);
  if (!legal) return null;
  return app.route('canela.about_page', {
    page: legal.slug ? `${id}-${legal.slug}` : String(id)
  });
}
export default function installPages() {
  const PagePage = 'ext:fof/pages/forum/components/PagePage';
  override(PagePage, 'hero', () => null);
  override(PagePage, 'content', function (original) {
    return [m("h1", {
      className: "CanelaRules-title CanelaPages-title"
    }, this.page?.title?.()), original()];
  });
  extend(PagePage, 'show', function () {
    const url = aboutUrlFor(Number(this.page?.id?.()));
    if (url) m.route.set(url, null, {
      replace: true
    });
  });
}
flarum.reg.add('ramon-canela', 'forum/thirdparty/pages', installPages);